// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"253":"1061cb1f","308":"395f550c","859":"f01dc933"}[chunkId] + ".chunk.js";
};